module.exports = {
	extends: [
		'/',
		'templates',
		'globals',
		'userSessions',
		'entity',
		'controller'
	],

	config: {
		usage: 'management',
		entityContext: 'userSessions'
	}
}